// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"TradeTypeChanger_horizontal__3p-xi"};